import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["card"];
import unescapedText from 'I18n/utils/unescapedText';
import { DownloadIcon } from 'foundations-assets';
import { bucketInstalls } from 'marketplace-ui-common/utils/installs';
import { EcosystemListingCard, translateProductType } from 'trellis-ecosystem';
import { jsx as _jsx } from "react/jsx-runtime";
export function StorefrontListingCard(_ref) {
  var _card$description, _card$listingName, _card$providerName;
  let {
      card
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const firstProduct = card.products[0];
  return /*#__PURE__*/_jsx(EcosystemListingCard, Object.assign({}, props, {
    certified: firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.certified,
    description: (_card$description = card.description) !== null && _card$description !== void 0 ? _card$description : '',
    imageSrcSmall: card.iconUrl,
    linkMode: "react-router",
    listingHref: `/listing/${card.slug}`,
    metaBadges: getMetaBadges(card),
    name: (_card$listingName = card.listingName) !== null && _card$listingName !== void 0 ? _card$listingName : '',
    providerName: (_card$providerName = card.providerName) !== null && _card$providerName !== void 0 ? _card$providerName : ''
  }));
}
function getMetaBadges(listing) {
  var _listing$installCount;
  // TODO: Handle multiple products?
  const firstProduct = listing.products[0];
  if (!firstProduct) return [];
  const badges = [{
    label: translateProductType(firstProduct.productType)
  }];
  const bucketedInstalls = bucketInstalls((_listing$installCount = listing.installCount) !== null && _listing$installCount !== void 0 ? _listing$installCount : 0);
  if (!firstProduct.installed) {
    badges.push({
      label: bucketedInstalls ? bucketedInstalls.toString() : unescapedText('marketplaceStorefront.cards.listingCard.fewInstalls'),
      icon: /*#__PURE__*/_jsx(DownloadIcon, {
        size: "100"
      })
    });
  }
  return badges;
}